var cookieNotice = {
    render: function(){
        var cookie_notice_container = jQuery('.cookie-notice'),
            cookie_notice_accept = jQuery('#cookie_notice_accept'),
            cookie_cname = 'accepted_cookie_notice';
            

        function setCookie(){
            localStorage.setItem("accepted_cookie_notice", "true");
        }

        function getCookie(){
            return localStorage.getItem("accepted_cookie_notice");
        }

        if (cookie_notice_container.length){

            if (getCookie() != 'true'){
                cookie_notice_container.show();
            }

            cookie_notice_accept.on('click', function(){
                cookie_notice_container.hide();
                setCookie();
                jQuery(document).off();
            });

            // if (cookie_notice_container.is(":visible")){
            //  jQuery(document).click(function() {
            //      cookie_notice_container.hide();
            //      setCookie();
            //      jQuery(document).off();
            //  }); 
            // }
        }
    },
    init: function(){
        this.render();
    }
};

cookieNotice.init();